import { render } from "./InfoWindowSite.vue?vue&type=template&id=f0bcc8aa"
import script from "./InfoWindowSite.vue?vue&type=script&lang=js"
export * from "./InfoWindowSite.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__